function moveInstallments() {
  const installments = document.querySelector('shopify-payment-terms');
  const installmentContainer = document.querySelector('.product-installments-wrapper')

  if (!installments || !installmentContainer) return;

  installmentContainer.appendChild(installments);
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.body.classList.contains('template-product') && window.screen.width <= 767) {
        moveInstallments();
    }
});

document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector('#delivery-promise-container');
  if (!el) return;

  el.style.padding = '0';
});

// Shadow DOM styling

document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector('#delivery-promise-container');
  if (!el) return;

  const waitForShadow = setInterval(() => {
    if (!el.shadowRoot) return;

    clearInterval(waitForShadow);

    const applyFix = () => {
      const shadow = el.shadowRoot;

      if (shadow.querySelector('#mobile-font-override')) return;

      const style = document.createElement('style');
      style.id = 'mobile-font-override';
      style.textContent = `
        @media (max-width: 767px) {
          * {
            font-size: 14px !important;
          }
          .dpp-entry {
            justify-content: unset !important;
          }
        }
      `;

      shadow.appendChild(style);
  
    };

    applyFix();

    const observer = new MutationObserver(() => {
      applyFix();
    });

    observer.observe(el.shadowRoot, { childList: true, subtree: true });
  }, 100);
});